import React, { useState } from 'react';
import { IconShare } from './icons';
import { ConversationActions } from './ConversationActions';
import type { ConversationSummary, ProjectSummary } from '../../lib/conversationsApi';
interface ConversationHeaderProps {
  conversation: ConversationSummary | null; projects: ProjectSummary[]; scopeLabel: string;
  onPin: () => void | Promise<void>; onArchive: () => void | Promise<void>;
  onMoveToProject: (id: string | null) => void | Promise<void>;
  onDelete: () => void | Promise<void>; onRename: (title: string) => void | Promise<void>; onShare: () => void;
}
export function ConversationHeader({ conversation, projects, scopeLabel, onPin, onArchive, onMoveToProject, onDelete, onRename, onShare }: ConversationHeaderProps) {
  const [detailsOpen, setDetailsOpen] = useState(false);
  if (!conversation) return null;
  return <header className="ozira-cw-header">
    <h2 className="ozira-cw-header-title">{conversation.title}</h2>
    <ConversationActions key={conversation.id} conversation={conversation} projects={projects} onAction={action => {
      switch (action.type) {
        case 'pin': return onPin(); case 'archive': return onArchive(); case 'delete': return onDelete();
        case 'rename': return onRename(action.title); case 'move': return onMoveToProject(action.projectId); case 'share': return onShare();
      }
    }} />
    <div className="ozira-cw-header-spacer" />
    <button type="button" className="ozira-cw-header-btn ozira-cw-share-label" onClick={onShare}><IconShare /> <span>Share</span></button>
    <button type="button" className="ozira-cw-header-btn" aria-label={detailsOpen ? 'Close conversation details' : 'Open conversation details'} aria-expanded={detailsOpen} aria-controls="conversation-details" onClick={() => setDetailsOpen(!detailsOpen)}>
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" aria-hidden="true"><rect x="3" y="4" width="18" height="16" rx="2" /><path d="M15 4v16" /></svg>
    </button>
    {detailsOpen && <aside className="ozira-conversation-details" id="conversation-details" aria-label="Conversation details">
      <button type="button" onClick={() => setDetailsOpen(false)}>Close details</button>
      <h3>{conversation.title}</h3><p>{scopeLabel}</p>
      <p>Project: {projects.find(project => project.id === conversation.projectId)?.name ?? 'No project'}</p>
      <p>{conversation.pinned ? 'Pinned' : 'Not pinned'} · {conversation.archived ? 'Archived' : 'Active'}</p>
    </aside>}
  </header>;
}
